import {httpsCallable} from "firebase/functions";
import {cloudFunctions} from "../firebase";

const callOnboardingFunction = async (name, payload) => {
    try {
        const callable = httpsCallable(cloudFunctions, name);
        const result = await callable(payload);
        return result.data;
    } catch (error) {
        const message = error?.message
            ?.replace(/^FirebaseError:\s*/i, "")
            ?.replace(/^functions\/[a-z-]+:\s*/i, "")
            || "Tiply could not complete that request. Please try again.";
        const normalized = new Error(message);
        normalized.code = error?.code || "functions/unknown";
        throw normalized;
    }
};

export const checkBusinessIdAvailability = (businessID) =>
    callOnboardingFunction("checkBusinessIdAvailability", {businessID});

export const completeBusinessSignup = (businessData) =>
    callOnboardingFunction("completeBusinessSignup", businessData);

export const createEmployee = (businessID, displayName) =>
    callOnboardingFunction("createEmployee", {businessID, displayName});

export const activateEmployee = (businessID, employeeID) =>
    callOnboardingFunction("activateEmployee", {businessID, employeeID});

export const setEmployeeStatus = (businessID, employeeID, status) =>
    callOnboardingFunction("setEmployeeStatus", {businessID, employeeID, status});

export const requestBusinessActivation = (businessID) =>
    callOnboardingFunction("requestBusinessActivation", {businessID});

export const reviewBusinessOnboarding = (businessID, decision, note = "") =>
    callOnboardingFunction("reviewBusinessOnboarding", {businessID, decision, note});
